/**
 * ScrollableView - Reusable scrollable content container
 * Provides consistent flex-1 overflow-y-auto layout with configurable gap spacing.
 */

import { ReactNode } from 'react';

const gapClasses: Record<number, string> = {
  0: '',
  4: 'space-y-4',
  6: 'space-y-6',
  8: 'space-y-8',
};

interface ScrollableViewProps {
  children: ReactNode;
  /** Vertical gap between children (maps to space-y-{N}). Default: 6 */
  gap?: 0 | 4 | 6 | 8;
  className?: string;
}

export function ScrollableView({ children, gap = 6, className = '' }: ScrollableViewProps) {
  const gapClass = gapClasses[gap] ?? 'space-y-6';
  return (
    <div className={`flex-1 overflow-y-auto p-6 ${gapClass} ${className}`.trim()}>
      {children}
    </div>
  );
}
